/**
 * 支払ステータスリスト
 */
export const PAYMENT_STATUS_TYPE = [
  '未支払い',
  '支払い済',
  'キャンセル',
] as const;

/**
 * 支払ステータス
 */
export type PaymentStatusType = typeof PAYMENT_STATUS_TYPE[number];
